import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";

const PartnersPage = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Partnerler" />
      <div className="card">
        <div className="card-body">
          <h5>Partnerler</h5>
          <p>Bu sayfa yakında eklenecek.</p>
        </div>
      </div>
    </MasterLayout>
  );
};

export default PartnersPage;

